import { Toast } from "../../CommonComponents";

export const internalPageSuccess = (message: string) => {
  Toast({
    message,
    type: "success",
  });
};
